/**
 * Data Transfer Object (DTO) for utilization calculation mode.
 * Represents the wire format used by the backend API.
 */

/**
 * Base DTO enum for utilization calculation mode.
 * Determines whether to calculate utilization against total capacity or billable capacity only.
 */
export enum UtilizationBasedOnDTO {
  TOTAL_CAPACITY = 'TOTAL_CAPACITY',
  BILLABLE_CAPACITY = 'BILLABLE_CAPACITY',
}

/**
 * Type alias for utilization mode in API requests.
 */
export type UtilizationBasedOnRequest = UtilizationBasedOnDTO;

/**
 * Type alias for utilization mode in API responses.
 */
export type UtilizationBasedOnResponse = UtilizationBasedOnDTO;
